// API Configuration for Calmren
// Points to Cloudflare Workers API

export const API_BASE_URL = import.meta.env.PROD
  ? 'https://api.calmren.com'
  : 'http://localhost:8787'

export default API_BASE_URL
